var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details-component"},[_c('div',{staticClass:"details-component__header"},[_c('h1',[_vm._v(_vm._s(_vm.$tc('kiosk.title', 2)))])]),_vm._v(" "),(_vm.kiosks)?_c('div',{staticClass:"details-component__content content"},[_c('v-client-table',{attrs:{"data":_vm.kiosks,"columns":_vm.columns,"options":_vm.options}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be4abb90","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/products/KiosksTable.vue
// module id = 1521
// module chunks = 65